'use client';

import { useClientConfig } from '@providers/ClientConfigProvider';
import { usePathname } from 'next/dist/client/components/navigation';
import { useEffect } from 'react';

export default function OneTapModule() {
  const config = useClientConfig();
  const loginUri = config.GRAPHQL_URL + '/auth/google-one-tap';
  const clientId = config.AUTH_GOOGLE_CLIENT_ID;
  const pathname = usePathname();
  const isCampaignRoute = typeof pathname === 'string' && pathname.includes('/campaign');

  useEffect(() => {
    if (!isCampaignRoute) {
      document.body.appendChild(
        Object.assign(document.createElement('script'), {
          src: 'https://accounts.google.com/gsi/client',
          async: true,
        }),
      );
    }
  }, [isCampaignRoute]);

  return (
    <div>
      <div
        id="g_id_onload"
        data-client_id={clientId}
        data-context="signin"
        data-ux_mode="redirect"
        data-login_uri={loginUri}
        data-nonce="false"
        data-auto_select="false"
        data-itp_support="true"
        data-cancel_on_tap_outside="false"
        data-color_scheme="light"
        data-theme="light"
      ></div>
    </div>
  );
}
